import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import SignUpFormContent from '../components/SignUpFormComponent'
import { useSignUpForm } from './SignUpForm.hooks'

const SignUpForm = props => {
	const [
		{
			captchaRef,
			data,
			settings,
			mobileAlignment,
			formikProps,
			className,
			classes,
			buttonText,
			title,
			titleConfig,
			placeholderColor,
			usePaperColors,
			fieldsPerRow,
			titleEditable,
			buttonTextEditable,
			buttonTextConfig,
			buttonTextKey,
			titleKey,
			rounded,
			white,
			image,
			withCaptcha,
			sx,
		},
		{
			handleFormSubmit,
			handleTitleClick,
			handleButtonClick,
			handleTitleChange,
			handleButtonTextChange,
			handleImageClick,
		},
	] = useSignUpForm(props)

	return (
		<Formik {...formikProps} onSubmit={handleFormSubmit}>
			{({ handleSubmit, isSubmitting, hasValidationErrors }) => (
				<SignUpFormContent
					captchaRef={captchaRef}
					className={className}
					placeholderColor={placeholderColor}
					buttonText={buttonText}
					usePaperColors={usePaperColors}
					title={title}
					titleConfig={titleConfig}
					titleEditable={titleEditable}
					classes={classes}
					fieldsPerRow={fieldsPerRow}
					settings={settings}
					handleSubmit={handleSubmit}
					isSubmitting={isSubmitting}
					data={data}
					withCaptcha={withCaptcha}
					hasValidationErrors={hasValidationErrors}
					onTitleClick={handleTitleClick}
					onButtonClick={handleButtonClick}
					onTitleChange={handleTitleChange}
					buttonTextEditable={buttonTextEditable}
					buttonTextConfig={buttonTextConfig}
					onButtonTextChange={handleButtonTextChange}
					titleKey={titleKey}
					buttonTextKey={buttonTextKey}
					rounded={rounded}
					mobileAlignment={mobileAlignment}
					white={white}
					image={image}
					onImageClick={handleImageClick}
					sx={sx}
				/>
			)}
		</Formik>
	)
}

SignUpForm.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		checkboxes: PropTypes.string,
		item: PropTypes.string,
		checkboxItem: PropTypes.string,
		buttonProgress: PropTypes.string,
		optIn: PropTypes.string,
		button: PropTypes.string,
		buttonText: PropTypes.string,
		privacy: PropTypes.string,
		link: PropTypes.string,
		title: PropTypes.string,
		input: PropTypes.string,
		checkbox: PropTypes.string,
		select: PropTypes.string,
		buttonWrap: PropTypes.string,
	}),
	buttonText: PropTypes.string,
	title: PropTypes.string,
	titleConfig: PropTypes.object,
	placeholderColor: PropTypes.string,
	usePaperColors: PropTypes.bool,
	titleEditable: PropTypes.bool,
	onSuccess: PropTypes.func,
	fieldsPerRow: PropTypes.oneOf([1, 2, 3, 4]),
	onTitleClick: PropTypes.func,
	onButtonClick: PropTypes.func,
	onTitleChange: PropTypes.func,
	buttonTextEditable: PropTypes.bool,
	buttonTextConfig: PropTypes.object,
	onButtonTextChange: PropTypes.func,
	titleKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	buttonTextKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	rounded: PropTypes.bool,
	mobileAlignment: PropTypes.string,
	white: PropTypes.bool,
	image: PropTypes.object,
	onImageClick: PropTypes.func,
	sx: PropTypes.shape({
		white: PropTypes.shape({
			lg: PropTypes.oneOf([false, true, 'theme']),
			md: PropTypes.oneOf([false, true, 'theme']),
			sm: PropTypes.oneOf([false, true, 'theme']),
			xs: PropTypes.oneOf([false, true, 'theme']),
		}),
		shadow: PropTypes.shape({
			lg: PropTypes.bool,
			md: PropTypes.bool,
			sm: PropTypes.bool,
			xs: PropTypes.bool,
		}),
	}),
}

export default memo(SignUpForm)
